/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Campus_DescriptionInputs */

const en_map_campus_description = /** @type {(inputs: Map_Campus_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planet-scale map with WGS84 GPS coordinates. Support planned in a future iteration.`)
};

const fr_map_campus_description = /** @type {(inputs: Map_Campus_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte à très grande échelle, coordonnées GPS WGS84. Prise en charge prévue dans une prochaine itération.`)
};

const ms_sg2_map_campus_description = /** @type {(inputs: Map_Campus_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peta skala besar dengan koordinat GPS WGS84. Sokongan dirancang dalam lelaran masa depan.`)
};

/**
* | output |
* | --- |
* | "Planet-scale map with WGS84 GPS coordinates. Support planned in a future iteration." |
*
* @param {Map_Campus_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const map_campus_description = /** @type {((inputs?: Map_Campus_DescriptionInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Campus_DescriptionInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_campus_description(inputs)
	if (locale === "fr") return fr_map_campus_description(inputs)
	return ms_sg2_map_campus_description(inputs)
});